import { Checkbox, Tooltip } from "antd"
import { PricingType, PricingTypes } from "../../../../../common/constants"

type Props = {
  pricingType: PricingType,
  isEditingGroupLevel: boolean
  canEditGroupFields: boolean,
  showTaxInFinalPrice: boolean,
  onChange: (value: boolean) => void
}

const ShowTaxInFinalPriceControl = ({pricingType, isEditingGroupLevel, canEditGroupFields, showTaxInFinalPrice, onChange}: Props) => {
  if (!isTaxDisplayedForPricingType(pricingType)) {
    return null
  }

  const disabled = !canEditGroupFields
  const description = isEditingGroupLevel ? 'The work areas in this group are taxable' : 'This work area is taxable'

  const checkbox = <Checkbox
    checked={showTaxInFinalPrice}
    onChange={(e) => onChange(e.target.checked)}
    disabled={disabled}
  >
    {description}
  </Checkbox>

  return disabled
    ? <Tooltip title="This can only be changed at the group level.">{checkbox}</Tooltip>
    : checkbox
}

export default ShowTaxInFinalPriceControl

export const isTaxDisplayedForPricingType = (pricingType: PricingType) => {
  if (pricingType === PricingTypes.QuotedPrice) {
    return true
  }
  if (pricingType === PricingTypes.PerVisit) {
    return true
  }
  return false
}
